import { Group, Stack, Text, Loader, ThemeIcon } from "@mantine/core";
import { IconCheck, IconCircle } from "@tabler/icons-react";
import { enrichmentStatusLabel } from "../_Shared/enrichment";

// The three real in-progress phases of enrichment, in order. LinkedIn fetch + web search run
// *inside* "extracting" (they aren't separate enum values); "pending" = queued, before any phase
// is active. Mirrors the EnrichmentStatus enum's visible in-progress states — keep in sync with
// _Shared/enrichment.js and the enrich_status_* keys in i18n.js.
const PHASES = ["extracting", "parsing", "embedding"];

/**
 * Compact live phase indicator for an in-progress enrichment: the three phases as a small vertical
 * stepper (done ✓ / active spinner / upcoming dot), driven by the candidate's current
 * enrichmentStatus. Render only while enrichment is running — the caller gates on enrichInProgress;
 * complete/failed states are shown by the surrounding badge, not here. `t` is the Veft-namespace t().
 */
export default function EnrichmentSteps({ status, t }) {
  const activeIdx = PHASES.indexOf(status); // -1 while "pending" (queued), or for any non-phase value

  return (
    <Stack gap={6} mt={4}>
      {status === "pending" && (
        <Text size="xs" c="dimmed">{enrichmentStatusLabel("pending", t)}</Text>
      )}
      {PHASES.map((phase, i) => {
        const done = activeIdx > i;
        const active = activeIdx === i;
        return (
          <Group key={phase} gap={8} wrap="nowrap" align="center">
            {active ? (
              <Loader size={14} />
            ) : done ? (
              <ThemeIcon size={16} radius="xl" color="teal" variant="light">
                <IconCheck size={11} />
              </ThemeIcon>
            ) : (
              <ThemeIcon size={16} radius="xl" color="gray" variant="light">
                <IconCircle size={8} />
              </ThemeIcon>
            )}
            <Text size="xs" c={active ? undefined : "dimmed"} fw={active ? 500 : undefined}>
              {enrichmentStatusLabel(phase, t)}
            </Text>
          </Group>
        );
      })}
    </Stack>
  );
}
